import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import Backend from "i18next-http-backend";
// import LanguageDetector from "i18next-browser-languagedetector";

// import ar from "./lang/ar.json";
import bg from "./lang/bg.json";
import cs from "./lang/cs.json";
import da from "./lang/da.json";
import de from "./lang/de.json";
import en from "./lang/en.json";
import es from "./lang/es.json";
import fi from "./lang/fi.json";
import fr from "./lang/fr.json";
import gu from "./lang/gu.json";
// import he from "./lang/he.json";
import hi from "./lang/hi.json";
import hu from "./lang/hu.json";
import id from "./lang/id.json";
import is from "./lang/is.json";
import it from "./lang/it.json";
import ja from "./lang/ja.json";
import kn from "./lang/kn.json";
import ko from "./lang/ko.json";
import ms from "./lang/ms.json";
import nl from "./lang/nl.json";
import pl from "./lang/pl.json";
import pt from "./lang/pt.json";
import ro from "./lang/ro.json";
import ru from "./lang/ru.json";
import sk from "./lang/sk.json";
import sv from "./lang/sv.json";
import te from "./lang/te.json";
import th from "./lang/th.json";
import tl from "./lang/tl.json";
import tr from "./lang/tr.json";
// import ur from "./lang/ur.json";
import vi from "./lang/vi.json";
import zh from "./lang/zh.json";

i18n
  // .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // debug: true,
    resources: {
      // ar: {
      //   translation: ar,
      // },
      bg: {
        translation: bg,
      },
      cs: {
        translation: cs,
      },
      da: {
        translation: da,
      },
      de: {
        translation: de,
      },
      en: {
        translation: en,
      },
      es: {
        translation: es,
      },
      fi: {
        translation: fi,
      },
      fr: {
        translation: fr,
      },
      gu: {
        translation: gu,
      },
      // he: {
      //   translation: he,
      // },
      hi: {
        translation: hi,
      },
      hu: {
        translation: hu,
      },
      id: {
        translation: id,
      },
      is: {
        translation: is,
      },
      it: {
        translation: it,
      },
      ja: {
        translation: ja,
      },
      kn: {
        translation: kn,
      },
      ko: {
        translation: ko,
      },
      ms: {
        translation: ms,
      },
      nl: {
        translation: nl,
      },
      pl: {
        translation: pl,
      },
      pt: {
        translation: pt,
      },
      ro: {
        translation: ro,
      },
      ru: {
        translation: ru,
      },
      sk: {
        translation: sk,
      },
      sv: {
        translation: sv,
      },
      te: {
        translation: te,
      },
      th: {
        translation: th,
      },
      tl: {
        translation: tl,
      },
      tr: {
        translation: tr,
      },
      // ur: {
      //   translation: ur,
      // },
      vi: {
        translation: vi,
      },
      zh: {
        translation: zh,
      },
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

// i18n.changeLanguage("en-US");

// console.log("i18n = ", i18n);

// Once the active language has been selected
// use
// i18n.changeLanguage('en-US'); -- 'en-US' replace with selected language

export default i18n;
